import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  Editing,
  Pager,
  Paging,
  RemoteOperations,
} from "devextreme-react/ui/data-grid";

import getForm from "./form";
import { doCreateEmpresa, doDeleteEmpresa, doUpdateEmpresa } from "./actions";
import ModalDelete from "../modalDelete";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";

class TableEmpresa extends React.PureComponent {
  constructor(props) {
    super(props);
    this.contador = 0;
    this.state = {
      modalDelete: false,
      eventDelete: null,
    };

    this.tableRef = React.createRef();
  }

  handleAdd = () => {
    this.tableRef.addRow();
  }
  handleOpenModalEdit = (r) => {
    this.tableRef.editRow(r.row.rowIndex);
  }

  handleOpenModalDelete = (r) => {
    this.tableRef.deleteRow(r.row.rowIndex);
  }

  handleSave = (event) => {
    this.props.dispatch(doCreateEmpresa(event.data.Name, event.data.Description));
  }

  handleDeleteEmpresa = () => {
    this.props.dispatch(doDeleteEmpresa(this.state.eventDelete.data.Id));
    this.setState({ modalDelete: false, eventDelete: null });
  }

  handleUpdate = (event) => {
    const data = { ...event.oldData, ...event.newData };
    this.props.dispatch(doUpdateEmpresa(data.Id, data.Name, data.Description, data.Active));
  }

  handleRemove = (event) => {
    if (this.state.eventDelete === null) {
      this.setState({ modalDelete: true, eventDelete: event });
      event.cancel = true;
    }
  }

  handleCancelRemove = () => {
    this.setState({ modalDelete: false, eventDelete: null });
  }
  handleFilterChange = (text) => {
    this.tableRef.searchByText(text);
  }

  render() {
    const {
      eventDelete,
    } = this.state;
    const form = getForm();

    return (
      <React.Fragment>


        <TableFilter
          placeholder="Buscar"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosTablaEmpresas}
          show={true}
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: false, buttonAction: null },
              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              /*newItem: {
                buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar empresa",
              },*/

            }
          }

        />

        <DataGrid
          dataSource={this.props.empresas}
          showBorders={false}
          noDataText="Sin Empresas"
          className="custom-table"
          showColumnLines={false}
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          showRowLines={false}
          rowAlternationEnabled
          onRowInserting={this.handleSave}
          onRowUpdating={this.handleUpdate}
          onRowRemoving={this.handleRemove}
        >

          <Editing
            form={form}
            mode="popup"
            popup={{
              title: "Empresas",
              showTitle: true,
              width: 700,
              dragEnabled: false,
              showCloseButton: true,
              height: 345,
              position: {
                my: "center",
                at: "center",
                of: window,
              },
            }}
            texts={{
              addRow: "Agregar Empresa",
              saveRowChanges: "Guardar",
              cancelRowChanges: "Cancelar",
              confirmDeleteMessage: "",
              deleteRow: "Borrar",
            }}
          />

          <Column
            allowEditing={false}
            allowAdding={false}
            caption="Empresa"
            allowSearch
            cellComponent={(item) => {
              return <UserInfoColumn
                nombre={item.data.companyName ? item.data.companyName : ""}
                rut={item.data.companyRut ? item.data.companyRut : ""}
              />
            }}
          />

          <Column
            dataField="companyGroup"
            allowEditing={false}
            allowAdding={false}
            caption="Grupo"
            allowSearch
          />

          <Column
            dataField="companySegment"
            allowEditing={false}
            allowAdding={false}
            caption="Segmento"
            allowSearch
          />

          <Column
            allowEditing={false}
            allowAdding={false}
            caption="Afiliación"
            allowSearch
            cellComponent={(item) => {
              return item.data.companySubsidiary ? <i className="achs-icon check"> X </i> : <i className="achs-icon uncheck"> W </i>
            }}
          />

          {/*<Column
            cellComponent={React.memo((props) => (
              // eslint-disable-next-line
              <div
                className="dx-button dx-button-success dx-button-mode-contained dx-widget dx-button-has-text slimButton"
                onClick={() => this.handleOpenModalEdit(props)}
              >
                <div className="dx-button-content"><span className="dx-button-text">Editar</span></div>
              </div>
            ))}
            />*/}

          <Pager
            visible
            showInfo
            infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
          />
          <Paging
            pageSize={20}
          />
          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />
        </DataGrid>
        <ModalDelete
          open={this.state.modalDelete}
          title="Eliminar empresa"
          step1Main={
            <React.Fragment>
              ¿Seguro quieres eliminar el empresa
              <span style={{ fontWeight: "bold", marginLeft: 3 }}>
                {eventDelete && eventDelete.data.Name}
              </span> ?
            </React.Fragment>
          }
          step1Sub="Al eliminar el empresa todos los usuarios que tengan este empresa asignado perderán sus privilegios."
          step2Main="Esta acción es irreversible"
          step2Sub="¿Seguro quieres eliminar el empresa?"
          step2ConfirmationText="Sí, quiero eliminar el empresa"
          deleteCallback={this.handleDeleteEmpresa}
          cancelCallback={this.handleCancelRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  empresas: state.mantenedores.empresas,
  filtrosTablaEmpresas: state.mantenedores.filtrosTablaEmpresas,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableEmpresa);
